var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"font-weight-medium"},[_vm._v("指定されたページは存在しません")])
}
var staticRenderFns = []

export { render, staticRenderFns }